import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XrSession } from '../../../../models/session.model';

@Component({
  selector: 'app-session-network-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex-1 overflow-y-auto p-4 space-y-4 custom-scrollbar">
      <div *ngIf="!session?.networkRequests || session?.networkRequests?.length === 0" class="text-center py-12 text-gray-500 text-sm">
        <div *ngIf="isLoadingNetworkRequests" class="animate-pulse">Cargando consumos web...</div>
        <div *ngIf="!isLoadingNetworkRequests">No hay consumos de red registrados en esta sesión.</div>
      </div>
      
      <div *ngIf="session?.networkRequests && session!.networkRequests!.length > 0" class="space-y-4">
        <!-- Apdex Score Box -->
        <div class="bg-black border border-zaxis-border rounded-none p-4 border border-zaxis-border flex flex-col gap-2 relative overflow-hidden">
          <div class="absolute inset-0 bg-gradient-to-r from-zaxis-accent/10 to-transparent pointer-events-none"></div>
          <h4 class="text-xs font-bold text-gray-400 uppercase tracking-wider">Apdex Global</h4>
          <div class="flex items-end gap-3">
            <span class="text-3xl font-bold font-mono" [ngClass]="getApdexColorClass(session?.apdexScore || 0)">{{ (session?.apdexScore || 0) | number:'1.2-2' }}</span>
            <span class="text-xs text-gray-500 mb-1">Index Score</span>
          </div>
          <div class="flex gap-4 text-xs mt-2">
            <div class="flex items-center gap-1"><div class="w-2 h-2 rounded-none bg-green-500"></div><span class="text-gray-400">{{ session?.apdexSatisfiedCount || 0 }} Satisfied</span></div>
            <div class="flex items-center gap-1"><div class="w-2 h-2 rounded-none bg-yellow-500"></div><span class="text-gray-400">{{ session?.apdexToleratingCount || 0 }} Tolerating</span></div>
            <div class="flex items-center gap-1"><div class="w-2 h-2 rounded-full bg-red-500"></div><span class="text-gray-400">{{ session?.apdexFrustratedCount || 0 }} Frustrated</span></div>
          </div>
        </div>

        <!-- Requests List -->
        <div class="space-y-2">
          <div *ngFor="let req of session!.networkRequests" class="bg-black border border-zaxis-border rounded-none p-3 border border-zaxis-border text-sm flex flex-col gap-1.5 relative overflow-hidden group hover:bg-white/5 transition-colors">
            <div class="absolute left-0 top-0 bottom-0 w-1" [ngClass]="{'bg-green-500': req.apdexCategory === 'Satisfied', 'bg-yellow-500': req.apdexCategory === 'Tolerating', 'bg-red-500': req.apdexCategory === 'Frustrated'}"></div>
            <div class="flex justify-between items-start pl-2">
              <span class="font-bold text-gray-300 uppercase text-[10px]">{{ req.method }}</span>
              <span class="font-mono text-[10px]" [ngClass]="req.statusCode >= 400 ? 'text-red-400' : 'text-green-400'">{{ req.statusCode }}</span>
            </div>
            <div class="pl-2 pr-1 w-full text-[11px] truncate text-white" [title]="req.url">{{ req.url }}</div>
            <div class="flex justify-between items-end pl-2">
              <span class="text-[10px] text-gray-500 font-mono">{{ formatTimestamp(session!.timestamp! + req.timestampOffsetMs) }}</span>
              <span class="font-mono font-bold text-xs" [ngClass]="{'text-green-400': req.apdexCategory === 'Satisfied', 'text-yellow-400': req.apdexCategory === 'Tolerating', 'text-red-400': req.apdexCategory === 'Frustrated'}">{{ req.durationMs }}ms</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class SessionNetworkPanelComponent {
  @Input() session?: XrSession | null;
  @Input() isLoadingNetworkRequests: boolean = false;
  
  getApdexColorClass(score: number): string {
    if (score >= 0.85) return 'text-green-400';
    if (score >= 0.70) return 'text-yellow-400';
    return 'text-red-400';
  }

  formatTimestamp(ts: number): string {
    const date = new Date(ts);
    return date.toISOString().split('T')[1].replace('Z', '');
  }
}
